var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.usuarioLogueado)?_c('LoginPlanificaciones',{on:{"login-success":_vm.handleLoginSuccess,"logout":_vm.handleLogout}}):_c('ScreenPlanificacionesAgenda',{attrs:{"usuarioExterno":_vm.usuario},on:{"logout":_vm.cerrarSesion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }